module.exports = __webpack_public_path__ + "img/hovered-layer2.6ff5549f.png";